module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-ko-KR.1a3eb650.jpg";